export const TableMock = () => {
  return (
    <svg
      width="212"
      height="174"
      viewBox="0 0 212 174"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.706543"
        y="0.338867"
        width="210.587"
        height="173.323"
        rx="7.95551"
        fill="#FFFDF9"
      />
      <rect
        x="1.13985"
        y="0.772174"
        width="209.72"
        height="172.456"
        rx="7.5222"
        stroke="#D7D3C9"
        strokeWidth="0.866613"
      />

      {/* Table background */}
      <rect
        x="-12.2927"
        y="16.8047"
        width="238.72"
        height="162.923"
        rx="2.00605"
        fill="#C1B7FF"
      />
      <rect
        x="-11.9417"
        y="17.1557"
        width="238.018"
        height="162.221"
        rx="1.65499"
        stroke="#D7D3C9"
        strokeWidth="0.702117"
      />

      {/* Table header */}
      <path
        d="M-2.7439 19.3885C-2.7439 17.9615 -1.58709 16.8047 -0.160106 16.8047H214.295C215.722 16.8047 216.878 17.9615 216.878 19.3885V40.0588H-2.7439V19.3885Z"
        fill="#FFFDF9"
      />

      {/* Table rows - simplified representation */}
      <rect
        x="-2.7439"
        y="40.0586"
        width="219.622"
        height="23.2541"
        fill="#FFFDF9"
      />
      <rect
        x="-2.7439"
        y="63.3125"
        width="219.622"
        height="23.2541"
        fill="#FFFDF9"
      />
      <rect
        x="-2.7439"
        y="86.5674"
        width="219.622"
        height="23.2541"
        fill="#FFFDF9"
      />
      <rect
        x="-2.7439"
        y="109.821"
        width="219.622"
        height="23.2541"
        fill="#FFFDF9"
      />
      <rect
        x="-2.7439"
        y="133.075"
        width="219.622"
        height="23.2541"
        fill="#FFFDF9"
      />

      {/* Grid lines */}
      <line
        x1="-2.7439"
        y1="40.0586"
        x2="216.878"
        y2="40.0586"
        stroke="#D7D3C9"
      />
      <line
        x1="-2.7439"
        y1="63.3125"
        x2="216.878"
        y2="63.3125"
        stroke="#D7D3C9"
      />
      <line
        x1="-2.7439"
        y1="86.5674"
        x2="216.878"
        y2="86.5674"
        stroke="#D7D3C9"
      />
      <line
        x1="-2.7439"
        y1="109.821"
        x2="216.878"
        y2="109.821"
        stroke="#D7D3C9"
      />
      <line
        x1="-2.7439"
        y1="133.075"
        x2="216.878"
        y2="133.075"
        stroke="#D7D3C9"
      />
      <line
        x1="-2.7439"
        y1="156.329"
        x2="216.878"
        y2="156.329"
        stroke="#D7D3C9"
      />

      {/* Column dividers */}
      <line
        x1="25.6778"
        y1="16.8047"
        x2="25.6778"
        y2="179.728"
        stroke="#D7D3C9"
      />
      <line
        x1="90.2725"
        y1="16.8047"
        x2="90.2725"
        y2="179.728"
        stroke="#D7D3C9"
      />
      <line
        x1="154.867"
        y1="16.8047"
        x2="154.867"
        y2="179.728"
        stroke="#D7D3C9"
      />

      {/* Header row content */}
      <rect
        x="33.4292"
        y="24.5557"
        width="36.1731"
        height="7.75137"
        rx="3.87569"
        fill="#D7D3C9"
      />
      <rect
        x="98.0239"
        y="24.5557"
        width="36.1731"
        height="7.75137"
        rx="3.87569"
        fill="#D7D3C9"
      />
      <rect
        x="162.619"
        y="24.5557"
        width="36.1731"
        height="7.75137"
        rx="3.87569"
        fill="#D7D3C9"
      />

      {/* Footer buttons */}
      <rect
        x="24.1038"
        y="159.796"
        width="32.0646"
        height="10.399"
        rx="2"
        fill="#ECE9DF"
      />
      <rect
        x="59.635"
        y="159.796"
        width="32.0647"
        height="10.399"
        rx="2"
        fill="#ECE9DF"
      />
      <rect
        x="95.166"
        y="159.796"
        width="32.065"
        height="10.399"
        rx="2"
        fill="#ECE9DF"
      />

      {/* Navigation controls */}
      <path
        d="M8.29175 6.29199H14.7084V7.20866H8.29175V6.29199Z"
        fill="#D7D3C9"
      />
      <path
        d="M8.29175 8.12533H12.3022V9.04199H8.29175V8.12533Z"
        fill="#D7D3C9"
      />
      <path
        d="M12.3022 11.792H8.29175V12.7087H12.3022V11.792Z"
        fill="#D7D3C9"
      />
      <path
        d="M8.29175 9.95866H14.7084V10.8753H8.29175V9.95866Z"
        fill="#D7D3C9"
      />
      <path
        d="M13.8489 168.405V165.139H17.1148V164.05H13.8489V160.784H12.7603V164.05H9.49438V165.139H12.7603V168.405H13.8489Z"
        fill="#A8A5A0"
      />
    </svg>
  );
};
